export default __webpack_public_path__ + "static/media/icon-social-notify.7cc54e4d.svg";